/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Newspage_Meta_DescInputs */

const en_fw_newspage_meta_desc = /** @type {(inputs: Fw_Newspage_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every Firefly Wedding announcement in one timeline: anime premiere, cast reveals, theme songs, manga volumes and the 2027 live-action drama.`)
};

const zh_fw_newspage_meta_desc = /** @type {(inputs: Fw_Newspage_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁所有公告一条时间线看完：动画首播、声优公布、主题曲、漫画新卷与 2027 年真人剧。`)
};

/**
* | output |
* | --- |
* | "Every Firefly Wedding announcement in one timeline: anime premiere, cast reveals, theme songs, manga volumes and the 2027 live-action drama." |
*
* @param {Fw_Newspage_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_newspage_meta_desc = /** @type {((inputs?: Fw_Newspage_Meta_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Newspage_Meta_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_newspage_meta_desc(inputs)
	return zh_fw_newspage_meta_desc(inputs)
});
export { fw_newspage_meta_desc as "fw.newspage.meta_desc" }